"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = exports.buildRelativePath = exports.trimTrailingSlash = exports.comparePaths = exports.normalizePath = exports.buildSearchString = void 0;
function buildSearchString(searchParams) {
    if (typeof searchParams === "string") {
        return searchParams ? searchParams : "";
    }
    const search = new URLSearchParams();
    Object.keys(searchParams).forEach((searchTerm) => {
        if (Array.isArray(searchParams[searchTerm])) {
            const searchValues = searchParams[searchTerm];
            searchValues.forEach((value) => search.append(searchTerm, String(value)));
        }
        else {
            search.append(searchTerm, String(searchParams[searchTerm]));
        }
    });
    return search.toString();
}
exports.buildSearchString = buildSearchString;
function normalizePath(path) {
    let cleanPath;
    if (path.includes("?") || path.includes("#")) {
        let firstOccuranceIndex = 0;
        if (path.includes("?") && path.includes("#")) {
            firstOccuranceIndex = Math.min(path.indexOf("?"), path.indexOf("#"));
        }
        else if (path.includes("#")) {
            firstOccuranceIndex = path.indexOf("#");
        }
        else {
            firstOccuranceIndex = path.indexOf("?");
        }
        cleanPath = path
            .substring(0, firstOccuranceIndex)
            .split("/")
            .filter((segment) => Boolean(segment))
            .join("/");
        const urlParams = path.substring(firstOccuranceIndex);
        return `/${cleanPath + urlParams}`;
    }
    cleanPath = path
        .split("/")
        .filter((segment) => Boolean(segment))
        .join("/");
    return `/${cleanPath}`;
}
exports.normalizePath = normalizePath;
function comparePaths(firstPath, secondPath) {
    const pathOne = normalizePath(firstPath);
    const pathTwo = normalizePath(secondPath);
    return pathOne === pathTwo;
}
exports.comparePaths = comparePaths;
function trimTrailingSlash(textToTrim) {
    const charArr = textToTrim.split("");
    while (charArr[charArr.length - 1] === "/") {
        charArr.pop();
    }
    return charArr.join("");
}
exports.trimTrailingSlash = trimTrailingSlash;
/**
 * Takes the base spa path, the destination pathname and the current pathname and
 * returns the final pathname.
 *
 * If the current pathname is a versioned segment, then that segment is applied to the final pathname.
 * A versioned segment is on the following form: '/tags/nameOfTheTag/' or '/versions/1.2.3/'.
 * The rule is then as follows: spaBasePath / moduleName / versionedSegment / (destinationPathname - moduleName )
 *
 * @param spaBasePath The basepath of the spa
 * @param currentPathname The current path name
 * @param destinationPathname The destination path name
 */
function buildRelativePath(spaBasePath, currentPathname, destinationPathname) {
    const versionMatch = currentPathname.match(/\/(versions|tags)\/.+?\//);
    const versionedSegment = versionMatch ? versionMatch[0] : null;
    if (versionedSegment) {
        const r = destinationPathname.match(/^(.+?)\/(.*)/);
        const destinationModule = r ? r[1] : "";
        const pathWithoutModule = r ? r[2] : "";
        const currentModule = currentPathname.replace(spaBasePath, "").split("/")[1];
        if (comparePaths(currentModule, destinationModule)) {
            const path = `${spaBasePath}/${destinationModule}/${versionedSegment}/${pathWithoutModule}`;
            return normalizePath(path);
        }
    }
    return normalizePath(`${spaBasePath}/${destinationPathname}`);
}
exports.buildRelativePath = buildRelativePath;
// Trim whitespace and remove any number of starting/ending slashes
const sanitize = (input) => {
    if (typeof input === "number")
        return input;
    return input?.trim().replace(/^\/+|\/+$/g, "");
};
const buildUrl = (apiUrl, segments) => new URL([apiUrl, ...segments].map(sanitize).join("/"));
exports.buildUrl = buildUrl;
